<template>
    <div class="products-scroller d-flex align-items-center bg-light py-3">
        <span @click="scrollLeft" class="track-left"><span class="ico-arrow-left larger"></span></span>

        <div class="track relative">
            <ul id="scroller-list" ref="scroller" class="relative d-flex">
                <li :class="{ selected: (selected === null) }" @click="reset">
                        <img class="all" src="/static/images/product_all.jpg">
                    <div class="title bold">See All</div>
                </li>

                <li :class="{ selected: (selected === category.id) }" v-for="category in categories" @click="toggleSelection($event, category)">
                    <div class="image"></div>
                    <div class="title bold">
                        {{ category.name | ellipsis(19) }}
                    </div>
                </li>
            </ul>
        </div>

        <span class="ml-auto track-right" @click="scrollRight"><span class="ico-arrow-right larger"></span></span>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        props: {
            newReservationSetup: Object,
            categories: Array,
        },
        data: function() {
            return {
                selected: null,
                scrollCount: 0,
                visibleElements: 6,
                currentScrollPos: 0
            }
        },
        computed: {
            ...mapGetters([
                'getEvents',
            ]),
            count: function() {
                var children = this.$refs.scroller.children;
                return (children !== undefined) ? this.$refs.scroller.children.length : 0;
            },
            liWidth: function() {
                var children = this.$refs.scroller.children;
                return (children !== undefined && children.length > 0) ? children[0].offsetWidth : 0;
            },
        },
        methods: {
            ...mapActions([
                'resetNewReservationSetup',
                'updateNewReservationSetup',
                'emptyNewReservationSetupList',
            ]),
            reset: function() {
                this.selected = null;

                this.updateNewReservationSetup({ event: null });
            },
            toggleSelection: function(e, category) {
                let events = this.getEvents.filter(i => i.product.category.id === category.id);

                this.selected = category.id;

                // Filter from all the events that match this category

                if (events.length > 0) {
                    this.updateNewReservationSetup({
                        event: events
                    });
                }
                else {
                    this.emptyNewReservationSetupList();
                }
            },
            scrollLeft: function(e) {
                if (this.scrollCount > 0) {
                    this.scrollCount--;
                    this.currentScrollPos += this.liWidth;
                    this.translate(this.currentScrollPos);
                }
            },
            scrollRight: function(e) {
                if (this.scrollCount <= this.count && (this.count - this.scrollCount > this.visibleElements)) {
                    this.scrollCount++;
                    this.currentScrollPos -= this.liWidth;
                    this.translate(this.currentScrollPos);
                }
            },
            translate: function(px) {
                this.$refs.scroller.style.transform = 'translate(' + px + 'px)';
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .products-scroller {
        padding: 0 10px 0 12px;

        .track-right {
            padding-right: 5px;
        }

        .track {
            overflow-x: hidden;
            margin: 0 6px 0 4px;

            ul {
                top: 0;
                left: 0;
                display: block;
                width: 100000px;
                transition: all .2s ease-in-out;

                > li {
                    position: relative;
                    border-radius: 6px;
                    cursor: pointer;

                    .image, .all {
                        border-radius: 6px;
                        border: 2px solid $light;
                        margin: 2px 3px;
                        width: 114px;
                        height: 64px;
                        background-color: $dark;
                    }

                    .title {
                        position: absolute;
                        width: 100%;
                        top: 50%;
                        left: 0;
                        transform: translateY(-50%);
                        padding: 0 0.5rem;
                        color: $lightest;
                        text-align: center;
                    }

                    &.selected {
                        .image, .all {
                            border-color: $brand;
                        }
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// ProductsScroller.vue?7082b054